/* AVRA_CARD_ARROWS (2026-10-10, Brandon)
   Desktop (a real mouse): every product card in a carousel - New Arrivals,
   Send a Hint, Complete the Look - gets a quiet < > on its photo, shown when
   the pointer is over the card. Click to step through all of that piece's
   photos (wrapping round). This replaces the old "hover and the photo
   changes" on carousel cards, so the photo only changes when she asks it to.

   Phones (rev. 2026-10-10 evening): the New Arrivals cards on the homepage
   get the same < >, always visible (there is no hover on a phone), a little
   smaller to suit the 2 x 2 grid. Other carousels on phones are unchanged.
   Holding a finger on a photo still peeks the other photo
   (assets/avra-touch-peek.js); that script ignores taps on buttons, so the
   arrows and the peek do not fight.

   Photos come from data-images on the card (snippets/avra-product-card). */
(function () {
  'use strict';
  if (!window.matchMedia) return;
  var fineQ = window.matchMedia('(hover: hover) and (pointer: fine)');

  var css =
    /* shared arrow look */
    '.prod__arr { position: absolute; top: 50%; z-index: 3; width: 32px; height: 32px; margin-top: -16px;' +
    ' display: grid; place-items: center; padding: 0; border: 0; border-radius: 50%;' +
    ' background: rgba(255,255,255,.88); color: #1a1813; cursor: pointer; opacity: 0;' +
    ' -webkit-tap-highlight-color: transparent; touch-action: manipulation;' +
    ' box-shadow: 0 1px 6px rgba(0,0,0,.08); transition: opacity .25s ease, background .2s ease; }' +
    '.prod__arr--prev { left: 10px; } .prod__arr--next { right: 10px; }' +
    '.prod__arr svg { display: block; pointer-events: none; }' +
    '.prod__arr:focus-visible { opacity: 1; outline: 1px solid #1a1813; outline-offset: 2px; }' +
    '.prod__media image-slot img.is-swapping { opacity: 0; }' +
    '.prod__media image-slot img { transition: opacity .22s ease; }' +
    /* desktop: show on hover, no more hover photo swap on carousel cards */
    '@media (hover: hover) and (pointer: fine) {' +
    '.carousel .prod__media--alt .prod__altimg, .carousel .prod__media--alt:hover .prod__altimg,' +
    '.carousel .prod__media--alt:focus-within .prod__altimg { display: none !important; }' +
    '.carousel .prod:hover .prod__media image-slot { transform: none !important; }' +
    '.prod:hover .prod__arr { opacity: 1; }' +
    '.prod__arr:hover { background: #fff; }' +
    '}' +
    /* phones / touch: New Arrivals arrows always visible, sized for the grid */
    '@media not all and (hover: hover) and (pointer: fine) {' +
    '[data-na-track] .prod__arr { opacity: 1; width: 28px; height: 28px; margin-top: -14px;' +
    ' background: rgba(255,255,255,.9); }' +
    '[data-na-track] .prod__arr--prev { left: 6px; } [data-na-track] .prod__arr--next { right: 6px; }' +
    '[data-na-track] .prod__arr svg { width: 12px; height: 12px; }' +
    '}';
  var st = document.createElement('style');
  st.textContent = css;
  (document.head || document.documentElement).appendChild(st);

  var CHEV_L = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var CHEV_R = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';

  function key(u) { return (u || '').split('?')[0].split('/').pop(); }
  function list(card) {
    var raw = card.getAttribute('data-images') || '';
    return raw.split('|').filter(Boolean);
  }

  function wire(card) {
    if (card.__arrows) return;
    var imgs = list(card);
    var media = card.querySelector('.prod__media');
    if (!media || imgs.length < 2) return;
    card.__arrows = true;
    var name = (card.querySelector('.prod__name') || {}).textContent || 'this piece';
    ['prev', 'next'].forEach(function (dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'prod__arr prod__arr--' + dir;
      b.setAttribute('aria-label', (dir === 'prev' ? 'Previous' : 'Next') + ' photo of ' + name.trim());
      b.setAttribute('data-arr', dir === 'prev' ? '-1' : '1');
      b.innerHTML = dir === 'prev' ? CHEV_L : CHEV_R;
      media.appendChild(b);
    });
  }

  function step(card, d) {
    var imgs = list(card);
    var img = card.querySelector('.prod__media image-slot img');
    if (!img || imgs.length < 2) return;
    var cur = key(img.getAttribute('src'));
    var i = 0;
    for (var k = 0; k < imgs.length; k++) if (key(imgs[k]) === cur) { i = k; break; }
    var next = imgs[(i + d + imgs.length) % imgs.length];
    var pre = new Image();
    img.classList.add('is-swapping');
    pre.onload = pre.onerror = function () {
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = next;
      img.classList.remove('is-swapping');
    };
    pre.src = next;
  }

  function wireAll() {
    var sel = fineQ.matches ? '.carousel .prod[data-images]' : '[data-na-track] .prod[data-images]';
    Array.prototype.forEach.call(document.querySelectorAll(sel), wire);
  }

  /* The arrow sits inside the card's link; stop the tap reaching it. Capture
     phase so this runs before the theme's own handlers. */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('.prod__arr');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var card = b.closest('.prod');
    if (card) step(card, parseInt(b.getAttribute('data-arr'), 10) || 1);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wireAll);
  else wireAll();
  window.addEventListener('load', wireAll);
  if (fineQ.addEventListener) fineQ.addEventListener('change', wireAll);
  /* carousels that render later (recommendations load by fetch, New Arrivals tabs) */
  if ('MutationObserver' in window) {
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(wireAll, 150); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
})();
